import { render, staticRenderFns } from "./ContactCollector.vue?vue&type=template&id=1bf7b968"
import script from "./ContactCollector.vue?vue&type=script&lang=js"
export * from "./ContactCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports